module.exports = __webpack_public_path__ + "img/orange-soldier.760a4f3d.png";